import React from "react";

const ModalProgramarSolicitud = ({
  handleProgramarModal,
  handleProgramar,
  handleChange,
  values,
  cotizaciones,
  solpeds,
  ocs,
  handleDocEntryChange,
  addDocEntry,
  removeDocEntry,
}) => {
  const { fecha_programada } = values;

  const renderEntries = (entries, type, label) => (
    <div className="col-md-12 mt-2">
      <label className="label-title">{label}</label>
      {entries.map((entry, index) => (
        <div key={index} className="doc-entry-row">
          <input
            type="number"
            className="inputFormGest doc-entry-nro"
            placeholder="Nro"
            value={entry.nro || ""}
            onChange={(e) =>
              handleDocEntryChange(type, index, "nro", e.target.value)
            }
          />
          <input
            type="datetime-local"
            className="inputFormGest doc-entry-fecha"
            value={entry.fecha || ""}
            onChange={(e) =>
              handleDocEntryChange(type, index, "fecha", e.target.value)
            }
          />
          <button
            type="button"
            className="doc-entry-remove"
            onClick={() => removeDocEntry(type, index)}
          >
            <i className="fa-solid fa-trash"></i>
          </button>
        </div>
      ))}
      <button
        type="button"
        className="doc-entry-add"
        onClick={() => addDocEntry(type)}
      >
        <i className="fa-solid fa-plus"></i> Agregar {label.split(" ").pop()}
      </button>
    </div>
  );

  return (
    <>
      <div className="container-modal " onClick={handleProgramarModal}></div>
      <div className="body-modal">
        <div className="header-modal mb-2">Programar solicitud</div>
        <div className="row ">
          <div className="col-md-12 p-3">
            <label className="label-title">Fecha Programación</label>
            <input
              type="datetime-local"
              className="w-100 inputFormGest"
              onChange={handleChange}
              name="fecha_programada"
              value={fecha_programada}
            />
          </div>
          {renderEntries(cotizaciones, "cot", "Cotizaciones")}
          {renderEntries(solpeds, "solped", "Solped")}
          {renderEntries(ocs, "oc", "Órdenes de Compra")}
        </div>
        <div className="footer-modal mt-3">
          <button className="btn btn-danger" onClick={handleProgramarModal}>
            Cerrar
          </button>
          <button className="btn btn-primary" onClick={handleProgramar}>
            Programar
          </button>
        </div>
      </div>
    </>
  );
};

export default ModalProgramarSolicitud;
